import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

type StorePlatform = 'ios' | 'android';

interface AppStoreLink {
  buttonLabel: string;
  qrImageUrl: string;
  storeUrl: string;
}

const STORE_LINKS: Record<StorePlatform, AppStoreLink> = {
  ios: {
    buttonLabel: 'App Store',
    qrImageUrl: 'assets/img/qr-ov-ios.png',
    storeUrl: 'https://apps.apple.com/us/app/intranet-ggm/id6754910753',
  },
  android: {
    buttonLabel: 'Google Play',
    qrImageUrl: 'assets/img/qr-ov-android.png',
    storeUrl: 'https://play.google.com/store/apps/details?id=com.intranetGomez',
  },
};

@Component({
  selector: 'app-app-download-links',
  imports: [ButtonModule],
  templateUrl: './app-download-links.component.html',
  styleUrl: './app-download-links.component.scss',
})
export class AppDownloadLinksComponent {
  private readonly platformId = inject(PLATFORM_ID);
  readonly dialogConfig = inject(DynamicDialogConfig<StorePlatform | null>);

  get visibleStores(): StorePlatform[] {
    const store = this.dialogConfig.data;
    if (store === 'ios') {
      return ['ios'];
    }
    if (store === 'android') {
      return ['android'];
    }
    return ['ios', 'android'];
  }

  getStoreConfig(store: StorePlatform): AppStoreLink {
    return STORE_LINKS[store];
  }

  openStoreInBrowser(store: StorePlatform): void {
    const url = this.getStoreConfig(store).storeUrl;
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
